// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"7b3d1110","611":"6ce2909e","761":"3249e1f5","947":"c35bdb79"}[chunkId] + ".chunk.js";
};